<template>
  <layout title="Classrooms">
    <div class="row">
      <div class="col-10">
        <h2>
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.index')"
          >
            Classrooms
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.edit', session.classroom.id)"
          >
            {{ session.classroom.name }}
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.sessions', session.classroom.id)"
          >
            Sessions
          </inertia-link>
          / {{ session.start_datetime }}
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="alert alert-info" v-if="isCompleted">
                  Completed class sessions cannot be edited.
                </div>

                <form @submit.prevent="update">
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Timezone
                    </label>
                    <div class="col-sm-10">
                      <select class="form-control">
                        <option value="">{{ timezone }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Start at
                    </label>
                    <div class="col-sm-10">
                      <input
                        class="form-control datetimepicker"
                        type="text"
                        name="start_datetime"
                        id="start_datetime"
                        v-model="form.start_datetime"
                      />
                      <div
                        v-if="errors && errors.start_datetime"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.start_datetime }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      End at
                    </label>
                    <div class="col-sm-10">
                      <input
                        class="form-control datetimepicker"
                        type="text"
                        name="end_datetime"
                        id="end_datetime"
                        v-model="form.end_datetime"
                      />
                      <div
                        v-if="errors && errors.end_datetime"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.end_datetime }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Status
                    </label>
                    <div class="col-sm-10">
                      <select class="form-control" v-model="form.status">
                        <option
                          v-for="status in status_options"
                          :key="status"
                          :value="status"
                          :selected="status == form.status"
                        >
                          {{ status }}
                        </option>
                      </select>
                      <div
                        v-if="errors && errors.end_time"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.status }}
                      </div>
                    </div>
                  </div>

                  <div class="form-check">
                    <label for="name" class="col-sm-2 col-form-label">
                      &nbsp;
                    </label>

                    <div class="form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="autoAcceptCB"
                      :checked="form.auto_accept"
                      v-model="form.auto_accept"
                    />
                    <label class="form-check-label" for="autoAcceptCB">
                      Accept join requests automatically
                    </label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <button
                        :disabled="isCompleted"
                        type="submit"
                        class="btn btn-primary float-right"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { onMounted } from "vue";
import AppLayout from "../../Layouts/AppLayout";
import "../../../jquery.datetimepicker.full";

export default {
  setup(props, context) {
    onMounted(() => {
      $(".datetimepicker").datetimepicker({
        minDate: 0,
        onChangeDateTime: function (dp, $input) {
          const name = $input[0].getAttribute("name");
          $input[0].dispatchEvent(new Event("input", { bubbles: true }));
        },
      });
    });
  },
  layout: AppLayout,
  props: {
    errors: Object,
    session: Object,
    status_options: Array,
    status_completed: String,
    timezone: String,
  },
  data() {
    return {
      form: {
        start_datetime: this.session.start_datetime,
        end_datetime: this.session.end_datetime,
        status: this.session.status,
        auto_accept: this.session.auto_accept,
      },
      isCompleted: this.session.status == "COMPLETED",
    };
  },
  methods: {
    update() {
      this.$inertia.patch(
        route("classrooms.sessions.update", this.session.id),
        this.form
      );
    },
  },
};
</script>
